// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Wmb3","header":"ReportDetails_header__2lNEY","title":"ReportDetails_title__zGeHv","left":"ReportDetails_left__23qld"};